import React from 'react';

interface SectionHeaderProps {
  children: React.ReactNode;
  className?: string;
  variant?: 'primary' | 'secondary' | 'alignement' | 'epaysage';
}

/**
 * Reusable section header component for print pages
 * - primary: Green background for main title (arbre)
 * - alignement: Steelblue background for alignement inventaires
 * - epaysage: Brown background for espace boisé inventaires
 * - secondary: Gray background for section titles
 */
export const SectionHeader = ({
  children,
  className = '',
  variant = 'secondary'
}: SectionHeaderProps) => {
  const primaryClasses = 'bg-[#02BC77] text-white py-[0.5px] px-3 print:py-2 print:px-3 text-center font-bold text-[1.313rem] print:text-[14px] tracking-wide text-center capitalize';
  const alignementClasses = 'bg-[#4682B4] text-white py-[0.5px] px-3 print:py-2 print:px-3 text-center font-bold text-[1.313rem] print:text-[14px] tracking-wide text-center capitalize';
  const epaysageClasses = 'bg-[#964B00] text-white py-[0.5px] px-3 print:py-2 print:px-3 text-center font-bold text-[1.313rem] print:text-[14px] tracking-wide text-center capitalize';
  const secondaryClasses = 'bg-[#808080] text-white py-1 px-3 print:py-2 print:px-3 text-[1.313rem] print:text-sm font-semibold print:tracking-wide text-center capitalize';

  const variantClasses = variant === 'primary'
    ? primaryClasses
    : variant === 'alignement'
      ? alignementClasses
      : variant === 'epaysage'
        ? epaysageClasses
        : secondaryClasses;

  return (
    <div className={`${variantClasses} ${className}`}>
      {children}
    </div>
  );
};
